import dayjs from "dayjs";
import { syncProgressPeriod } from "./market";

export const formatDuration = (notBefore: string, notAfter: string) => {
  return `${dayjs(notBefore).format("YYYY.MM.DD")} ~ ${syncProgressPeriod(dayjs(notAfter)).format("YYYY.MM.DD")}`;
};
